/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type StudentNavbarQueryVariables = {
    enableShop: boolean;
};
export type StudentNavbarQueryResponse = {
    readonly viewer: {
        readonly avatar: string;
        readonly profile: {
            readonly " $fragmentRefs": FragmentRefs<"useClaimStartingCoinsFragment">;
        };
        readonly " $fragmentRefs": FragmentRefs<"SunflowerNavbar_viewer">;
    };
};
export type StudentNavbarQuery = {
    readonly response: StudentNavbarQueryResponse;
    readonly variables: StudentNavbarQueryVariables;
};



/*
query StudentNavbarQuery(
  $enableShop: Boolean!
) {
  viewer {
    avatar
    ...SunflowerNavbar_viewer_2S09y7
    profile {
      __typename
      ...useClaimStartingCoinsFragment_2S09y7
      ... on Node {
        __isNode: __typename
        id
      }
      ... on Teacher {
        id
      }
    }
    id
  }
}

fragment SunflowerNavbar_viewer_2S09y7 on User {
  profile @include(if: $enableShop) {
    __typename
    ... on Student {
      background {
        url
        type
        name
        isUnlocked
      }
      gamification {
        coinsBalance
        id
      }
    }
    ... on Node {
      __isNode: __typename
      id
    }
    ... on Teacher {
      id
    }
  }
}

fragment useClaimStartingCoinsFragment_2S09y7 on Student {
  gamification @include(if: $enableShop) {
    hasClaimedStartingCoins
    id
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "enableShop"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "avatar",
  "storageKey": null
},
v2 = [
  {
    "kind": "Variable",
    "name": "enableShop",
    "variableName": "enableShop"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = [
  (v3/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "StudentNavbarQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "profile",
            "plural": false,
            "selections": [
              {
                "args": (v2/*: any*/),
                "kind": "FragmentSpread",
                "name": "useClaimStartingCoinsFragment"
              }
            ],
            "storageKey": null
          },
          {
            "args": (v2/*: any*/),
            "kind": "FragmentSpread",
            "name": "SunflowerNavbar_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "StudentNavbarQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "profile",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "condition": "enableShop",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Gamification",
                        "kind": "LinkedField",
                        "name": "gamification",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "hasClaimedStartingCoins",
                            "storageKey": null
                          },
                          (v3/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ]
                  }
                ],
                "type": "Student",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": (v4/*: any*/),
                "type": "Node",
                "abstractKey": "__isNode"
              },
              {
                "kind": "InlineFragment",
                "selections": (v4/*: any*/),
                "type": "Teacher",
                "abstractKey": null
              }
            ],
            "storageKey": null
          },
          (v3/*: any*/),
          {
            "condition": "enableShop",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "profile",
                "plural": false,
                "selections": [
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "DashboardBackground",
                        "kind": "LinkedField",
                        "name": "background",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "url",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "type",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "name",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isUnlocked",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Gamification",
                        "kind": "LinkedField",
                        "name": "gamification",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "coinsBalance",
                            "storageKey": null
                          },
                          (v3/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "Student",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "9e18087f8b582532838d921c28cd248f",
    "id": null,
    "metadata": {},
    "name": "StudentNavbarQuery",
    "operationKind": "query",
    "text": "query StudentNavbarQuery(\n  $enableShop: Boolean!\n) {\n  viewer {\n    avatar\n    ...SunflowerNavbar_viewer_2S09y7\n    profile {\n      __typename\n      ...useClaimStartingCoinsFragment_2S09y7\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n      ... on Teacher {\n        id\n      }\n    }\n    id\n  }\n}\n\nfragment SunflowerNavbar_viewer_2S09y7 on User {\n  profile @include(if: $enableShop) {\n    __typename\n    ... on Student {\n      background {\n        url\n        type\n        name\n        isUnlocked\n      }\n      gamification {\n        coinsBalance\n        id\n      }\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n    ... on Teacher {\n      id\n    }\n  }\n}\n\nfragment useClaimStartingCoinsFragment_2S09y7 on Student {\n  gamification @include(if: $enableShop) {\n    hasClaimedStartingCoins\n    id\n  }\n}\n"
  }
};
})();
(node as any).hash = 'd4081cf9c1be31ace4ed0763151d2809';
export default node;
